import {$host} from './index';
import jwtDecode from 'jwt-decode';

const handleUnauthorized = () => {
    localStorage.removeItem('token');
    throw new Error('Unauthorized');
};

export const getUserById = async (id) => {
   const {data} = await $host.get(`web/user/${id}`);
   return data;
}

export const login = async (phone, password) => {
    try {
        const {data} = await $host.post('web/user/login', {phone, password});
        
        // Проверяем что токен существует
        if (!data.token) {
            console.error('No token in response:', data);
            throw new Error('Токен не получен от сервера');
        }
        
        console.log('Token received:', data.token.substring(0, 50) + '...');
        
        localStorage.setItem('token', data.token);
        
        try {
            const dataDecoded = jwtDecode(data.token);
            return dataDecoded.user;
        } catch (decodeError) {
            console.error('Token decode error:', decodeError);
            console.error('Token was:', data.token);
            throw new Error('Ошибка декодирования токена: ' + decodeError.message);
        }
    } catch (error) {
        if (error.response?.status === 401) handleUnauthorized();
        throw error;
    }
};

export const check = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
        handleUnauthorized();
    }

    try {
        const {data} = await $host.get('web/user/auth');
        localStorage.setItem('token', data.token);
        const dataDecoded = jwtDecode(data.token);
        return dataDecoded.user;
    } catch (error) {
        if (error.response?.status === 401) handleUnauthorized();
        throw error;
    }
};

export const changePassword = async (currentPassword, newPassword) => {
    try {
        const {status} = await $host.post('web/user/changepass', {
            currentPassword,
            newPassword,
        });
        return status;
    } catch (error) {
        if (error.response?.status === 401) handleUnauthorized();
        throw new Error('Не получилось сменить пароль');
    }
};

export const change = async (phone, name, internalName) => {
    try {
        const {data} = await $host.post('web/user/change', {phone, name, internalName});
        localStorage.setItem('token', data.token);
        const dataDecoded = jwtDecode(data.token);
        return dataDecoded.user;
    } catch (error) {
        if (error.response?.status === 401) handleUnauthorized();
    }
};

export const fetchFilteredPointsHistory = async (payload) => {
    const {data} = await $host.post('web/points_history', payload);
    return data;
};

export const fetchAllPointsHistory = async () => {
    const {data} = await $host.get(`web/points_history`);
    return data;
};


export const blockUser = async (phone, blocking) => {
    const {data} = await $host.post('web/user/block', {phone, blocking});
    return data;
};


export const changeAdminStatus = async (userId, needToBeAdmin) => {
    const {data} = await $host.post('web/user/change_admin_status', {needToBeAdmin, userId});
    return data;
};


export const getComments = async (userId) => {
    const {data} = await $host.get(`web/user/${userId}/comments`);
    return data;
};


export const postComment = async (userId, value) => {
    const {data} = await $host.post(`web/user/${userId}/comments`, {value});
    return data;
};

export const updateComment = async (commentId, value) => {
    const {data} = await $host.patch(`web/user/comments/${commentId}`, {value});
    return data;
};


export const deleteComment = async (commentId) => {
    const {data} = await $host.delete(`web/user/comments/${commentId}`);
    return data;
};

export const saveOrUpdateChild = async (parentUserId, name, birthday, childUserId) => {
    const {data} = await $host.post('web/user/child', {
        parentUserId,
        name,
        birthday,
        childUserId
    });
    return data;
};

export const detachChild = async (childUserId) => {
    const {data} = await $host.delete(`web/user/child/${childUserId}`);
    return data;
};

export const getChildren = async (userId) => {
    const {data} = await $host.get(`web/user/${userId}/children`);
    return data.children;
};

export const getAllBalances = async (userId) => {
    const {data} = await $host.get(`web/user/${userId}/balances`);
    return data;
};
